import { createFeatureSelector } from "@ngrx/store";

import { AuthActions, AuthActionTypes } from "./auth.actions";
import { AdminSession, CustomerSession } from "libs/tm-common/src/lib/models/user.model";

export interface AuthState {
	signedIn: boolean;
	isAdmin: boolean;
	user: AdminSession | CustomerSession;
}

export const initialAuthState: AuthState = {
	signedIn: false,
	isAdmin: false,
	user: undefined
};

export const selectAuthState = createFeatureSelector<AuthState>('auth');

export function reducer(state = initialAuthState, action: AuthActions): AuthState {
	switch (action.type) {
		case AuthActionTypes.EnrichAuthStateAction:
			return {
				...state,
				signedIn: true,
				user: action.payload
			};
		case AuthActionTypes.EnrichAuthStateAdminAction:
			return {
				...state,
				signedIn: true,
				isAdmin: true,
				user: action.payload
			};

		case AuthActionTypes.LogoutAction:
		case AuthActionTypes.NoHttpAuthAction:
		case AuthActionTypes.ClearAuthStateAction:
			return {
				...state,
				signedIn: false,
				isAdmin: false,
				user: undefined
			};

		default:
			return state;
	}
}
